import './FundItem.sass';
import './ETFEstimate.sass';
import { useArticles } from '../api';
import { useETFEstimate } from '../api';
import Breadcrumbs from '../components/Breadcrumbs';
import Hero from '../components/Hero';
import Loading from './Loading';
import Meta from '../components/Meta';
import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom'
import NoData from '../components/NoData';

const ETFEstimate = (props) => {
	const { routeData } = props;
	const { breadcrumbs } = useArticles(routeData.guid, routeData.route);
	const { apiData, note, isLoading, isError } = useETFEstimate();
	const [agreed, setAgreed] = useState(false);

	const isError400 = useMemo(() => {
		if (isError?.responseStatus?.message === '即時預估淨值無資料') return true;
		return false;
	}, [isError]);

	const isError500 = useMemo(() => {
		if (isError) return true;
		return false;
	}, [isError]);

	if (isError400) return (
		<div className='FundItem' id='ETFEstimate'>
			<Meta data={routeData} />
			<Hero data={breadcrumbs} />
			<Breadcrumbs data={breadcrumbs} />
			<NoData />
		</div>
	)

	if (isLoading || isError500) return <Loading />;

	return (
		<div className='FundItem' id='ETFEstimate'>
			<Meta data={routeData} />
			<Hero data={breadcrumbs} />
			<Breadcrumbs data={breadcrumbs} />

			{agreed ? (
				<div className='common-pad-wrap'>
					<div className='table-wrap'>
						<table>
							<thead>
								<tr>
									<th rowSpan='2'>證券代碼</th>
									<th rowSpan='2'>基金名稱</th>
									<th colSpan='4'>淨值</th>
									<th colSpan='4'>市價</th>
									<th colSpan='2'>折溢價</th>
									<th rowSpan='2'>
										即時
										<br />
										追蹤
										<br />
										差距
										<br />
										(台幣)
									</th>
									<th rowSpan='2'>
										即時
										<br />
										追蹤
										<br />
										差距
										<br />
										(原幣)
									</th>
									<th rowSpan='2'>
										基金
										<br />
										營業
										<br />日
									</th>
								</tr>

								<tr>
									<th>
										昨收
										<br />
										淨值
										<br />A
									</th>
									<th>
										預估
										<br />
										淨值
										<br />B
									</th>
									<th>
										漲跌
										<br />
										B-A
									</th>
									<th>
										漲跌幅 <br />
										(B-A)/A
									</th>
									<th>
										昨收
										<br />
										市價
										<br />C
									</th>
									<th>
										最新
										<br />
										市價
										<br />D
									</th>
									<th>
										漲跌
										<br />
										D-C
									</th>
									<th>
										漲跌幅
										<br />
										(D-C)/C
									</th>
									<th>
										折溢價
										<br />
										D-B
									</th>
									<th className='border-right'>
										幅度
										<br />
										(D-B)/B
									</th>
								</tr>
							</thead>

							<tbody>
								{apiData.map((item, index) => {
									const { etf002, twNameFull, yNav, yDate, nNav, nDates, change, changeRange, mlNav, mnNav, mChange, mChangeRange, pChange, pChangeRange, iTChangeRange, iChangeRange, cDate, mlDate, mnDate } = item;

									const getBullBear = (string) => {
										const trimmed = string.replace('%', '');
										const num = Number(trimmed);
										const isNumber = !Number.isNaN(num);

										if (isNumber && num > 0) return 'bull';
										if (isNumber && num < 0) return 'bear';

										return '';
									}

									return (
										<tr key={`row${index}`}>
											<td>{etf002}</td>

											<td>{twNameFull}</td>

											<td>
												{yNav}
												<div className='light'>{yDate}</div>
											</td>

											<td>
												{nNav}
												<div className='light'>{nDates}</div>
											</td>

											<td>
												<div className={`range ${getBullBear(change)}`}>
													<div className='text'>{change}</div>
													<div className='icon'></div>
												</div>
											</td>

											<td>
												<div className={`range ${getBullBear(changeRange)}`}>
													<div className='text'>{changeRange}</div>
													<div className='icon'></div>
												</div>
											</td>

											<td>
												{mlNav}
												<div className='light'>{mlDate}</div>
											</td>

											<td>
												{mnNav}
												<div className='light'>{mnDate}</div>
											</td>

											<td>
												<div className={`range ${getBullBear(mChange)}`}>
													<div className='text'>{mChange}</div>
													<div className='icon'></div>
												</div>
											</td>

											<td>
												<div className={`range ${getBullBear(mChangeRange)}`}>
													<div className='text'>{mChangeRange}</div>
													<div className='icon'></div>
												</div>
											</td>

											<td>
												<div className={`range ${getBullBear(pChange)}`}>
													<div className='text'>{pChange}</div>
													<div className='icon'></div>
												</div>
											</td>

											<td>
												<div className={`range ${getBullBear(pChangeRange)}`}>
													<div className='text'>{pChangeRange}</div>
													<div className='icon'></div>
												</div>
											</td>

											<td>
												<div className={`range ${getBullBear(iTChangeRange)}`}>
													<div className='text'>{iTChangeRange}</div>
													<div className='icon'></div>
												</div>
											</td>

											<td>
												<div className={`range ${getBullBear(iChangeRange)}`}>
													<div className='text'>{iChangeRange}</div>
													<div className='icon'></div>
												</div>
											</td>

											<td>{cDate}</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>

					<div className='note'>{note}</div>

					<div className='notes'>
						<div className='flex-row'>備註 : </div>

						<div className='flex-row'>
							<div className='num'>(1)</div>
							<div className='text'>即時預估淨值：根據基金投資組合中的股票即時成交價格乘上前一日基金投資組合乘上即時匯率所計算出的單位淨值，約每15秒即時更新一次。</div>
						</div>

						<div className='flex-row'>
							<div className='num'>(2)</div>
							<div className='text'>最新價格：投資人於次級市場進行基金買賣，即時撮合的交易價格。</div>
						</div>

						<div className='flex-row'>
							<div className='num'>(3)</div>
							<div className='text'>
								評價匯率：上述即時匯率訊息僅供參考。實際評價匯率依基金信託契約相關條款所訂，國外資產淨值之匯率兌換，由外幣轉換為美元，再由美元轉換為新臺幣，應以計算日中華民國時間下午三時彭博資訊(Bloomberg)所示收盤匯率為計算依據。如計算日當日無法取得彭博資訊(Bloomberg)所提供之收盤匯率時，以路透社(Reuters)所提供之資訊代之。如計算日無收盤匯率或無法取得者，則以最近之收盤匯率為準。
							</div>
						</div>

						<div className='flex-row'>
							<div className='num'>(4)</div>
							<div className='text'>
								即時追蹤差距：即時基金績效與標的指數表現之偏離度。若無法取得即時指數值資料時，將以可取得之最近營業日之基金績效與標的指數差異，加計即時匯率計算
							</div>
						</div>

						<div className='flex-row'>
							<div className='num'>(5)</div>
							<div className='text'>上述各項數據僅供參考，市價之各項數據為基金在台灣掛牌交易的狀況，以新台幣計價；該價格及漲跌幅部分仍應以台灣證券交易所公佈為準；淨值則應以大華銀投信最終公佈之每日淨值為準。</div>
						</div>

						<div className='flex-row'>
							<div className='num'>(6)</div>
							<div className='text'>台灣證券交易所交易時間：週一～週五9：00～13：30</div>
						</div>

						<div className='flex-row'>
							<div className='num'>(7)</div>
							<div className='text'>資料更新時間為每營業日 8:30 ~ 17:00，台灣地區若為非營業日，當日停止提供即時預估淨值之相關資料。惟因使用者個別網路傳輸品質速度不同可能影響更新頻率或時間。</div>
						</div>

						<div className='flex-row'>
							<div className='num'>(8)</div>
							<div className='text'>
								以上資料係本公司為服務投資人所提供，內容僅供參考，本公司不負擔保其正確性或即時性之責任，如有任何疏漏、錯誤，或因網路、系統問題，包括但不限於斷線、壅塞、延宕等情事，或者其他因使用、取得、下載本網頁資料所造成之任何損害，本公司均不負賠償責任。使用以上資料請投資人自行評估考量並承擔風險。
							</div>
						</div>
					</div>
				</div>
			) : (
				<div className='common-pad-wrap'>
					<div className='agree-wrap'>
						<div className='section-title'>
							<div className='text'>資料風險預告及免責條款</div>
							<div className='line'></div>
						</div>

						<p>
							任何由大華銀投信(下稱本公司)為服務廣大投資人而製作之報價資料僅限作參考用，每15秒提供最新即時之估計淨值，但因基金投資個股之組合差異甚大、價格波動迅速，及投資人個別使用之網路連線情形或傳輸品質狀況，亦可能影響其更新頻率時間差異，故仍請注意以上資料僅供參考，且盤中即時交易價格以台灣證交所公佈為準，本公司不擔保其為完全正確無誤，且對於本網站所提供之資訊內容本公司有權隨時修改或刪除。{' '}
						</p>

						<p>
							若因任何資料之不正確、疏漏，或如遇網路斷線、股價報價延遲、系統延宕...等不可抗力之情事，所衍生之損害或損失，本公司均不負法律責任。各基金之最後基金淨值，應另以本公司收盤結算後之公告為準。投資人在做任何相關規劃與決定之前，仍應請教專業人員針對投資人自身個別的情況提供專業意見，以符合投資人專屬的投資需求。依據本網站取得任何資料，應由您自行考量且自負風險，如因任何資料之下載而導致您電腦系統之任何損壞或資料流失，應由下載人自負完全責任。
						</p>

						<div className='buttons'>
							<Link to='/' className='button'>不同意</Link>
							<div
								className='button cta'
								onClick={() => {
									setAgreed(true);
									window.scrollTo(0, 0);
								}}>
								同意
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default ETFEstimate;
